/* subtle. — scroll reveals, card fan, tap-to-flip. */
(function () {
  if (window.__subtle) return; window.__subtle = true;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root) {
    root = root || document;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, d = reduce ? 0 : +(el.dataset.delay || 0);
        setTimeout(function () { el.classList.add('is-in'); }, d);
        io.unobserve(el);
      });
    }, { threshold: 0.18 });
    root.querySelectorAll('.sb-reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
    var fan = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-fanned');
        fan.unobserve(e.target);
      });
    }, { threshold: 0.4 });
    root.querySelectorAll('[data-sb-fan]').forEach(function (el) { fan.observe(el); });
    root.querySelectorAll('[data-sb-flip]').forEach(function (el) {
      el.addEventListener('click', function () { el.classList.toggle('is-flipped'); });
    });
    root.querySelectorAll('[data-sb-count]').forEach(function (ta) {
      var out = ta.closest('form').querySelector('[data-sb-count-out]');
      if (out) ta.addEventListener('input', function () { out.textContent = ta.value.length; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
